import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'

const AppsPage = lazy(() => import('./AppsPage/AppsPage'))

const routes = {
  path: '/apps',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<AppsPage />} />
    </LazyLoad>
  )
}

export default routes
